import { Colors } from '../designTokens/reactTokens/colors';

/**
 * Colors
 * - Figma: https://www.figma.com/file/36q2en2Fb6AAepdm1I6NGn/Design-system?node-id=62%3A18043
 * - Aurora Docs: https://aurora.iterable.com/latest/foundations/color/tokens-ZdmwqdFK
 */

export const baseColors = {
  purple10: Colors.basePrimaryPurple10,
  purple20: Colors.basePrimaryPurple20,
  purple50: Colors.basePrimaryPurple50,
  purple60: Colors.dataVizPurple60,
  purple70: Colors.basePrimaryPurple70,
  purple90: Colors.basePrimaryPurple90,
  purple100: Colors.basePrimaryPurple100,
  green10: Colors.basePrimaryGreen10,
  green20: Colors.basePrimaryGreen20,
  green50: Colors.basePrimaryGreen50,
  green90: Colors.dataVizGreen90,
  green100: Colors.basePrimaryGreen100,
  cognac80: Colors.dataVizCognac80,
  cyan10: Colors.basePrimaryCyan10,
  cyan20: Colors.basePrimaryCyan20,
  cyan50: Colors.basePrimaryCyan50,
  cyan80: Colors.dataVizCyan80,
  cyan100: Colors.basePrimaryCyan100,
  red10: Colors.basePrimaryRed10,
  red20: Colors.basePrimaryRed20,
  red50: Colors.basePrimaryRed50,
  red60: Colors.dataVizRed60,
  red100: Colors.basePrimaryRed100,
  mustard10: Colors.baseSecondaryMustard10,
  mustard20: Colors.baseSecondaryMustard20,
  mustard50: Colors.baseSecondaryMustard50,
  mustard100: Colors.baseSecondaryMustard100,
  salmon10: Colors.baseSecondarySalmon10,
  salmon20: Colors.baseSecondarySalmon20,
  salmon50: Colors.baseSecondarySalmon50,
  salmon80: Colors.dataVizSalmon80,
  salmon100: Colors.baseSecondarySalmon100,
  black: Colors.basePrimaryGreyBlack,
  white: Colors.basePrimaryGreyWhite,
  grey1: Colors.basePrimaryGrey1,
  grey5: Colors.basePrimaryGrey5,
  grey10: Colors.basePrimaryGrey10,
  grey15: Colors.basePrimaryGrey15,
  grey25: Colors.basePrimaryGrey25,
  grey35: Colors.basePrimaryGrey35,
  grey50: Colors.basePrimaryGrey50,
  grey60: Colors.basePrimaryGrey60,
  grey80: Colors.basePrimaryGrey80,
  grey90: Colors.basePrimaryGrey90,
  midnight80: Colors.dataVizMidnight80,
  midnight100: Colors.baseTertiaryMidnight100,
  ocean80: Colors.dataVizOcean80,
  ocean100: Colors.baseTertiaryOcean100,
  forest90: Colors.dataVizForest90,
  forest100: Colors.baseTertiaryForest100,
  seabreeze100: Colors.baseTertiarySeabreeze100,
  lime100: Colors.baseTertiaryLime100,
  lemon100: Colors.baseTertiaryLemon100,
  tangerine100: Colors.baseTertiaryTangerine100,
  cottoncandy100: Colors.baseTertiaryCottoncandy100,
  flamingo100: Colors.baseTertiaryFlamingo100,
  lavenderLighten40: Colors.baseTertiaryLavenderlighten40,
  lavenderLighten100: Colors.baseTertiaryLavenderlighten100,
  violet80: Colors.baseTertiaryViolet80,
  success100: Colors.utilityPositive100,
  warning100: Colors.utilityWarning100,
  overlay: Colors.bgOverlayOverlayModal,
  secondaryText: Colors.textSecondary,
};
export type BaseColors = typeof baseColors;

export const primaryColors = {
  purple100: Colors.basePrimaryPurple100,
  purple90: Colors.basePrimaryPurple90,
  purple70: Colors.basePrimaryPurple70,
  purple50: Colors.basePrimaryPurple50,
  purple20: Colors.basePrimaryPurple20,
  purple10: Colors.basePrimaryPurple10,
  green100: Colors.basePrimaryGreen100,
  green50: Colors.basePrimaryGreen50,
  green20: Colors.basePrimaryGreen20,
  green10: Colors.basePrimaryGreen10,
  cyan100: Colors.basePrimaryCyan100,
  cyan50: Colors.basePrimaryCyan50,
  cyan20: Colors.basePrimaryCyan20,
  cyan10: Colors.basePrimaryCyan10,
  red100: Colors.basePrimaryRed100,
  red50: Colors.basePrimaryRed50,
  red10: Colors.basePrimaryRed10,
};
export type PrimaryColors = typeof primaryColors;

export const secondaryColors = {
  mustard100: Colors.baseSecondaryMustard100,
  mustard50: Colors.baseSecondaryMustard50,
  mustard20: Colors.baseSecondaryMustard20,
  mustard10: Colors.baseSecondaryMustard10,
  salmon100: Colors.baseSecondarySalmon100,
  salmon50: Colors.baseSecondarySalmon50,
  salmon20: Colors.baseSecondarySalmon20,
  salmon10: Colors.baseSecondarySalmon10,
};
export type SecondaryColors = typeof secondaryColors;

export const tertiaryColors = {
  midnight100: Colors.baseTertiaryMidnight100,
  ocean100: Colors.baseTertiaryOcean100,
  forest100: Colors.baseTertiaryForest100,
  seabreeze100: Colors.baseTertiarySeabreeze100,
  lime100: Colors.baseTertiaryLime100,
  lemon100: Colors.baseTertiaryLemon100,
  tangerine100: Colors.baseTertiaryTangerine100,
  cottoncandy100: Colors.baseTertiaryCottoncandy100,
  flamingo100: Colors.baseTertiaryFlamingo100,
};
export type TertiaryColors = typeof tertiaryColors;

export const neutrals = {
  grey90: Colors.basePrimaryGrey90,
  grey80: Colors.basePrimaryGrey80,
  grey60: Colors.basePrimaryGrey60,
  grey50: Colors.basePrimaryGrey50,
  grey35: Colors.basePrimaryGrey35,
  grey25: Colors.basePrimaryGrey25,
  grey15: Colors.basePrimaryGrey15,
  grey10: Colors.basePrimaryGrey10,
  grey5: Colors.basePrimaryGrey5,
  grey1: Colors.basePrimaryGrey1,
  white: Colors.basePrimaryGreyWhite,
};
export type Neutrals = typeof neutrals;

export const brandColors = {
  brandPurple: Colors.basePrimaryPurple100,
  brandGreen: Colors.basePrimaryGreen50,
  brandCyan: Colors.basePrimaryCyan50,
  brandRed: Colors.basePrimaryRed50,
  brandMustard: Colors.baseSecondaryMustard50,
  brandSalmon: Colors.baseSecondarySalmon50,
  brandGrey: Colors.basePrimaryGrey50,
};
export type BrandColors = typeof brandColors;

export const utilityColors = {
  interactive100: Colors.utilityInteractive100,
  interactive50: Colors.utilityInteractive50,
  interactive10: Colors.utilityInteractive10,
  positive100: Colors.utilityPositive100,
  positive50: Colors.utilityPositive50,
  positive10: Colors.utilityPositive10,
  negative100: Colors.utilityNegative100,
  negative50: Colors.utilityNegative50,
  negative10: Colors.utilityNegative10,
  warning100: Colors.utilityWarning100,
  warning50: Colors.utilityWarning50,
  warning10: Colors.utilityWarning10,
  info100: Colors.utilityInfo100,
  info50: Colors.utilityInfo50,
  info10: Colors.utilityInfo10,
};
export type UtilityColors = typeof utilityColors;

export const textColors = {
  textPrimary: Colors.textPrimary,
  textSecondary: Colors.textSecondary,
  textDisabled: Colors.textDisabled,
  textOnColor: Colors.textOnColor,
  textOnColorSecondary: Colors.textOnColorSecondary,
  textInteractive: Colors.textInteractive,
  textInteractiveHover: Colors.textInteractiveHover,
  textDestructive: Colors.textDestructive,
  textSuccess: Colors.textSuccess,
  textWarning: Colors.textWarning,
  textInfo: Colors.textInfo,
  textLink: Colors.textLink,
};
export type TextColors = typeof textColors;

export const backgroundColors = {
  backgroundPrimary: Colors.bgPrimary,
  backgroundPrimaryHover: Colors.bgPrimaryHover,
  backgroundSecondary: Colors.bgSecondary,
  backgroundSecondaryHover: Colors.bgSecondaryHover,
  backgroundTertiary: Colors.bgTertiary,
  backgroundTertiaryHover: Colors.bgTertiaryHover,
  backgroundEmphasis: Colors.bgEmphasis,
  backgroundStrong: Colors.bgStrong,
  backgroundStrongHover: Colors.bgStronghover,
  backgroundDisabled: Colors.bgDisabled,
  backgroundDisabledStrong: Colors.bgDisabledStrong,
  backgroundInteractive: Colors.bgInteractive,
  backgroundInteractiveStrong: Colors.bgInteractiveStrong,
  backgroundDestructive: Colors.bgDestructive,
  backgroundDestructiveSubtle: Colors.bgDestructiveSubtle,
  backgroundDestructiveStrong: Colors.bgDestructiveStrong,
  backgroundSuccess: Colors.bgSuccess,
  backgroundSuccessSubtle: Colors.bgSuccessSubtle,
  backgroundWarning: Colors.bgWarning,
  backgroundWarningSubtle: Colors.bgWarningSubtle,
  backgroundInfo: Colors.bgInfo,
  backgroundInfoSubtle: Colors.bgInfoSubtle,
  backgroundDark: Colors.bgDark,
  backgroundScreen: Colors.bgOverlayOverlayModal,
  backgroundSegmentedControl: Colors.bgSelectedcontrol,
  backgroundSegmentedControlHover: Colors.bgSelectedcontrolhover,
  backgroundDarkOverlay: 'rgba(0,0,0,0.72)',
};
export type BackgroundColors = typeof backgroundColors;

export const linkColors = {
  link: Colors.textInteractive,
  linkHover: Colors.textInteractiveHover,
  linkActive: Colors.textInteractiveHover,
  linkFocus: Colors.textInteractiveHover,
  linkFocusOutline: Colors.borderInteractiveStrong,
  linkDisabled: Colors.textDisabled,
};
export type LinkColors = typeof linkColors;

export const borderColors = {
  neutral300: '#E9ECEF', // Custom color, not in design tokens
  borderPrimary: Colors.borderPrimary,
  borderPrimarySubtle: Colors.borderPrimarySubtle,
  borderStrong: Colors.borderStrong,
  borderEmphasis: Colors.borderEmphasis,
  borderOnColor: Colors.borderOnColor,
  borderInteractive: Colors.borderInteractive,
  borderInteractiveSubtle: Colors.borderInteractiveSubtle,
  borderInteractiveStrong: Colors.borderInteractiveStrong,
  borderDestructive: Colors.borderDestructive,
  borderDestructiveSubtle: Colors.borderDestructiveSubtle,
  borderSuccess: Colors.borderSuccess,
  borderSuccessSubtle: Colors.borderSuccessSubtle,
  borderWarning: Colors.borderWarning,
  borderWarningSubtle: Colors.borderWarningSubtle,
  borderInfo: Colors.borderInfo,
  borderInfoSubtle: Colors.borderInfoSubtle,
  outlineDark: Colors.borderOutlinedark,
  outlineLight: Colors.borderOutlinelight,
};
export type BorderColors = typeof borderColors;

export const iconColors = {
  iconPrimary: Colors.iconPrimary,
  iconPrimaryHover: Colors.iconPrimaryHover,
  iconSubtle: Colors.iconSubtle,
  iconDisabled: Colors.iconDisabled,
  iconEmphasis: Colors.iconEmphasis,
  iconOnColor: Colors.iconOnColor,
  iconOnColorSubtle: Colors.iconOnColorSubtle,
  iconInteractive: Colors.iconInteractive,
  iconInteractiveSubtle: Colors.iconInteractiveSubtle,
  iconInteractiveHover: Colors.iconInteractiveHover,
  iconDestructive: Colors.iconDestructive,
  iconSuccess: Colors.iconSuccess,
  iconWarning: Colors.iconWarning,
  iconInfo: Colors.iconInfo,
  iconFolder: Colors.iconFolder,
};
export type IconColors = typeof iconColors;

export const highchartColorPalette = [
  Colors.dataVizPurple100,
  Colors.dataVizGreen90,
  Colors.dataVizCyan80,
  Colors.dataVizRed60,
  Colors.dataVizSalmon80,
  Colors.dataVizForest90,
  Colors.dataVizCognac80,
  Colors.dataVizMidnight80,
  Colors.dataVizPurple60,
  Colors.basePrimaryPurple50,
  Colors.basePrimaryGreen50,
  Colors.basePrimaryCyan50,
  Colors.basePrimaryRed50,
];
export type HighchartColorPalette = typeof highchartColorPalette;

export const standardChartColors = {
  first: Colors.dataVizPurple100,
  second: Colors.dataVizGreen90,
  third: Colors.dataVizRed60,
  fourth: Colors.dataVizCyan80,
  fifth: Colors.dataVizSalmon80,
  other: Colors.dataVizGray50,
};

export type StandardChartColors = typeof standardChartColors;

export const comparisonChartColors = {
  first: Colors.dataVizCyan80,
  second: Colors.dataVizSalmon80,
};

export type ComparisonChartColors = typeof comparisonChartColors;

export const relatedChartColors = {
  purplePalette: {
    first: Colors.dataVizPurple100,
    second: Colors.dataVizPurple60,
  },
  greenPalette: {
    first: Colors.dataVizForest90,
    second: Colors.dataVizGreen90,
  },
  bluePalette: {
    first: Colors.dataVizMidnight80,
    second: Colors.dataVizCyan80,
  },
};

export type RelatedChartColors = typeof relatedChartColors;

export const colors = {
  ...baseColors,
  ...brandColors,
  ...utilityColors,
  ...textColors,
  ...backgroundColors,
  ...linkColors,
  ...borderColors,
  ...iconColors,
  ...highchartColorPalette,
};
